<template>
  <div class="ima-messages" v-if="errors.length">
    <b-notification v-for="error in errors" :key="error.id" type="is-danger" has-icon @close="onClose(error.id)">
      {{error.message}}
      <span v-if="error.code">(Code: {{error.code}})</span>
    </b-notification>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { solveError } from '@/store/mutations'
export default {
  name: 'ima-messages',
  data () {
    return {}
  },
  methods: {
    ...mapMutations([solveError]),
    onClose (id) {
      this.solveError(id)
    }
  },
  computed: {
    ...mapState(['errors'])
  }
}
</script>

<style lang="scss">
.ima-messages {
  position: fixed;
  left: 50%;
  top: 0;
  padding: 2rem;
  transform: translate(-50%, 0);
  width: 100%;
  z-index: 999999;

  .notification {
    animation: bounceIn 0.3s cubic-bezier(0.23, 0.58, 0.65, 1.3);
    font-weight: 600;
  }

  @keyframes bounceIn {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      transform: none;
    }
  }

  .media {
    // Gets added by buefy
    align-items: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Messages.vue